// src/components/admin/EditUserModal.tsx

import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

interface EditUserModalProps {
  show: boolean;
  onHide: () => void;
  onSave: (id: number, role: string, isActive: boolean) => void;
  user: {
    id: number;
    email: string;
    role: string;
    is_active: boolean;
  } | null;
}

export const EditUserModal = ({ show, onHide, onSave, user }: EditUserModalProps) => {
  const [role, setRole] = useState("client");
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (user) {
      setRole(user.role);
      setIsActive(user.is_active);
    }
  }, [user]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (user) {
      onSave(user.id, role, isActive);
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Edit User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              value={user?.email || ""}
              readOnly
              plaintext
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Role</Form.Label>
            <Form.Select
              value={role}
              onChange={(e) => setRole(e.target.value)}
            >
              <option value="owner">Owner</option>
              <option value="admin">Admin</option>
              {/* <option value="manager">Manager</option> */}
              <option value="client">Client</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Active</Form.Label>
            <Form.Select
              value={isActive ? "true" : "false"}
              onChange={(e) => setIsActive(e.target.value === "true")}
            >
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default EditUserModal;
